import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
console.log(process.env.REACT_APP_API);
// Конфігурація Firebase
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API,
  authDomain: process.env.REACT_APP_AUTHFIREBASE,
  projectId: process.env.REACT_APP_PROGECTID,
  storageBucket: process.env.REACT_APP_STORAGE,
  messagingSenderId: process.env.REACT_APP_MESSAGEID,
  appId: process.env.REACT_APP_APPID,
  measurementId: process.env.REACT_APP_MEASUREID,
};

// Ініціалізація Firebase
const app = initializeApp(firebaseConfig);

// Ініціалізація Firestore
export const firestore = getFirestore(app);
